import React from 'react';
import PropTypes from 'prop-types';

import withIdContext from '../../decorators/withIdContext';

const InlineLayout = ({
  children,
}) => (
  <div className="flex-columns">
    { children }
  </div>
);

InlineLayout.propTypes = {
  /** any React components to render in grid layout */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

InlineLayout.defaultProps = {
  children: null,
};

export default withIdContext()(InlineLayout);
